// src/components/MusicController.jsx
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useAudioManager } from "../@shared/utils/useAudioManager";
import { useSoundsStore } from "../@shared/store/useSoundsStore";
import AudioManager from "../@shared/utils/AudioManager";

export default function MusicController() {
  const location = useLocation();
  const { playBackgroundMusic } = useAudioManager();
  const musicBank = useSoundsStore((s) => s.musicBank);

  // ← **NEW**: subscribe to your volume setting
  const musicVolume = useSoundsStore((s) => s.musicVolume);
  const isMusicMuted = useSoundsStore((s) => s.isMusicMuted);

  // Fisher–Yates shuffle
  const shuffleArray = (arr) => {
    const a = [...arr];
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  };

  const lastScreen = useRef(null);

  useEffect(() => {
    const path = location.pathname.split("/")[1];
    // map your URL paths to the keys you used when preloading
    const screenKey =
      {
        "": "dashboard",
        gameboard: "gameboard",
        lobby: "lobby",
        mycards: "mycards",
      }[path] || "dashboard";

    // Grab the array of URLs (or empty array)
    const uris = musicBank[screenKey] || [];

    // shuffle so playback order varies each visit
    const shuffled = shuffleArray(uris);

    console.log("🎶 MusicController: switching to", screenKey, shuffled);

    // Tear down anything already playing:
    AudioManager.stopMusic();

    // if muted, bail out
    if (isMusicMuted) return;

    // Start the playlist for this screen:
    AudioManager.playPlaylist(shuffled, musicVolume);
  }, [location.pathname, musicBank, isMusicMuted]);

  // 🔊 Volume sync effect: only when volume or mute toggles
  useEffect(() => {
    if (isMusicMuted) {
      AudioManager.stopMusic();
    } else {
      AudioManager.setMusicVolume(musicVolume);
    }
  }, [musicVolume, isMusicMuted]);

  return null;
}
